import { createI18n } from 'vue-i18n'
import en from '../locales/en.json'
import fr from '../locales/fr.json'

const i18n = createI18n({
  locale: 'fr',
  messages: {
    fr,
    en,
  },
  datetimeFormats: {
    fr: {
      short: {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      },
      medium: {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
      },
      long: {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      },
      time: {
        hour: '2-digit',
        minute: '2-digit',
      },
    },
    en: {
      short: {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      },
      medium: {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
      },
      long: {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      },
      time: {
        hour: '2-digit',
        minute: '2-digit',
      },
    },
  },
})

export default i18n
